package org.hs_soft.runmynesto.pages.home.sub_page.statistic.component.tabs.bill_search.components

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.BillSearchDetailTableHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.StatisticFlagType
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.BillSearchStatisticDataItem
import org.hs_soft.runmynesto.domain.model.home.statistic.tabs.search_bill.statistic_data.Item
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.formatToTwoDecimals
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.jetbrains.compose.web.css.CSSColorValue


@Composable
fun SelectedBillSearchItemDetailTable(
    selectedBillSearchItem: BillSearchStatisticDataItem?,
) {
    val (columns, tableData) = setBillSearchDetailTableInfo(
        items = selectedBillSearchItem?.items,
    )

    CustomTable(
        columns = columns,
        data = tableData,
        itemBackground = { row ->
            (row["backgroundColor"] as? CSSColorValue) ?: Theme.Transparent.rgb
        },
        minHeight = Dimen.selectedBillSearchTableHeight,
        showRefreshButton = false,
        footerType = FooterType.NONE,
        selectedId = selectedBillSearchItem?.id,
        onRefresh = {}
    )
}

private fun setBillSearchDetailTableInfo(
    items: List<Item?>?,
): Pair<List<TableColumn>, List<Map<String, Any?>>?> {

    val columns = BillSearchDetailTableHeadersEnum.entries.map { header ->
        TableColumn(
            header = header.title,
            key = header.key,
            isNumeric = header.isNumeric,
            isSortable = true,
            sortFunction = when (header) {
                BillSearchDetailTableHeadersEnum.AMOUNT,
                BillSearchDetailTableHeadersEnum.PERCENT,
                BillSearchDetailTableHeadersEnum.TOTAL -> { row ->
                    val value = row[header.key]?.toString() ?: "0"
                    value.replace(",", ".").toDoubleOrNull() ?: 0.0
                }
                BillSearchDetailTableHeadersEnum.IN_HOUSE -> { row ->
                    val value = row[header.key]?.toString() ?: "0"
                    if (value.isBlank()) 0.0 else value.toDoubleOrNull() ?: 0.0
                }
                else -> null
            },
            customContent = if (header == BillSearchDetailTableHeadersEnum.IN_HOUSE) {
                { row ->
                    {
                        val isInHouse = row[BillSearchDetailTableHeadersEnum.IN_HOUSE.key]
                                as? Boolean ?: false
                        if (isInHouse) {
                            CustomIcon(
                                icon = Res.PathIcon.verify,
                                iconColor = Theme.ActionActive.hex,
                                onIconClick = {}
                            )
                        }
                    }
                }
            } else null
        )
    }

    val tableData = items?.map { item ->
        val backgroundColor = when (item?.flag) {
            StatisticFlagType.TOTAL_AMOUNT.value -> Theme.Green50.rgb
            StatisticFlagType.TOTAL_IN_CHF.value -> Theme.Blue50.rgb
            else -> Theme.Transparent.rgb
        }

        mapOf(
            "id" to (item?.id ?: ""),
            "flag" to item?.flag,
            "backgroundColor" to backgroundColor,
            BillSearchDetailTableHeadersEnum.IN_HOUSE.key to
                    (item?.mul1 != null && item.mul1 != 0.0),
            BillSearchDetailTableHeadersEnum.AMOUNT.key to formatToTwoDecimals(item?.amount),
            BillSearchDetailTableHeadersEnum.NAME.key to
                    when (item?.flag) {
                        StatisticFlagType.TOTAL_AMOUNT.value ->
                            LanguageManager.getCurrentStrings().total
                        StatisticFlagType.TOTAL_IN_CHF.value ->
                            LanguageManager.getCurrentStrings().given
                        else -> item?.product?.name ?: ""
                    },
            BillSearchDetailTableHeadersEnum.PERCENT.key to
                    formatToTwoDecimals(item?.discountPercent),
            BillSearchDetailTableHeadersEnum.VAT.key to
                    if(item?.codeMWSt == null) "" else (
                            (LanguageManager.getCurrentStrings().vat + "." + item.codeMWSt
                                .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() })),
            BillSearchDetailTableHeadersEnum.TOTAL.key to formatToTwoDecimals(item?.total)
        )
    }?.sortedWith(compareBy { row ->
        // Sort order: regular items (0), TOTAL_IN_CHF (1), TOTAL_AMOUNT (2)
        when (row["flag"]) {
            StatisticFlagType.TOTAL_IN_CHF.value -> 1
            StatisticFlagType.TOTAL_AMOUNT.value -> 2
            else -> 0
        }
    })?.toMutableList() ?: mutableListOf()

    return Pair(columns, tableData)
}